"use client";

import { ComparisonItem as ComparisonItemType } from "../../../__generated__/contentful-types";
import { useImageLoading } from "../../../helpers/ImageLoadingContext";
import { getContentfulImageUrl } from "../../../helpers/contentful/images/getContentfulImageUrl";
import classnames from "classnames/bind";
import styles from "./comparison-item.module.css";

const cx = classnames.bind(styles);

export const ComparisonItem = ({ card }: { card: ComparisonItemType }) => {
  const imageLoading = useImageLoading();

  return (
    <div className={cx("container")}>
      <ul role="list" className={cx("face")}>
        <li className={cx("title-wrapper")}>
          <span className={cx("title")}>{card.title}</span>
        </li>
        <li>
          <span className={cx("amount")}>{card.amount}</span>
          <span className={cx("per250ml")}>{card.per250Ml}</span>
        </li>
      </ul>
      <div className={cx("face", "face--align-end")}>
        {card.artwork?.url &&
          (card.artwork.contentType === "video/mp4" ? (
            <video
              className={cx("artwork")}
              preload="auto"
              autoPlay={true}
              playsInline={true}
              muted={true}
              loop={true}
              src={getContentfulImageUrl(card.artwork.url, {})}
            />
          ) : (
            <picture>
              {(["avif", "webp"] as const).map((format, index) => (
                <source
                  key={index}
                  type={`image/${format}`}
                  srcSet={[1, 1.5, 2]
                    .map((retinaMultiplier) => {
                      const width = Math.ceil(retinaMultiplier * 155);
                      const src = getContentfulImageUrl(
                        card.artwork?.url ?? "",
                        {
                          fm: format,
                          q: 100,
                          width,
                        },
                      );

                      return `${src} ${width}w`;
                    })
                    .join(", ")}
                />
              ))}
              <img
                className={cx("artwork")}
                src={getContentfulImageUrl(card.artwork.url, {})}
                alt={card.artwork.description ?? undefined}
                draggable={false}
                loading={imageLoading}
              />
            </picture>
          ))}
        {card.additionalInfo && (
          <span className={cx("additional-info")}>{card.additionalInfo}</span>
        )}
      </div>
    </div>
  );
};
